<template>
  <div>
    <div
      v-if="!expense"
      class="base64-upload"
    >
      <input
        class="input-file"
        type="file"
        accept=".jpeg,.jpg,.png,.pdf,.doc,.docx,.xls,.xlsx"
        @input="onChange"/>
      <p
        v-if="isInitial"
        class="message"
      >
        {{ $lang.messages.selectYourFile }}
      </p>
      <p
        v-if="isInitial"
        class="sub-message"
      >
        {{ $lang.messages.dragAndDropTypes }}
      </p>
      <p
        v-if="!isInitial"
        class="message"
      >
        {{ $lang.messages.selectAnotherFile }}
      </p>
      <p
        v-if="!isInitial"
        class="sub-message"
      >
        {{ fileName }}
      </p>
    </div>

    <div
      v-if="expense"
      class="base64-upload expense"
    >
      <input
        class="input-file"
        type="file"
        accept=".jpeg,.jpg,.png,.pdf,.doc,.docx,.xls,.xlsx"
        multiple
        @change="onChange" />
      <span
        v-if="isInitial"
        class="sub-message"
      >
        {{ $lang.messages.dragAndDrop }}
      </span>
      <span
        v-if="isInitial"
        class="message"
      >
        {{ $lang.messages.chooseFiles }}
      </span>

      <p
        v-if="!isInitial"
        class="message"
      >
        {{ $lang.messages.selectAnotherFile }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    expense: {
      type: Boolean,
      required: false,
      default: () => false
    },
    numberOfFiles: {
      type: Number,
      required: true,
      default: () => 0
    }
  },
  data() {
    return {
      fileName: "",
      fileNames: []
    }
  },
  computed: {
    isInitial() {
      if (this.numberOfFiles === 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    onChange(event) {
      if (this.expense) {
        if(event.target.files) {
          for (let index = 0; index < event.target.files.length; index++) {
            const element = event.target.files[index];
            const filesize = ((element.size/1024)/1024).toFixed(2);
            if (filesize <= 10) {
              let reader = new FileReader()
              reader.addEventListener('load', e => {
                const mimeType = this.generateMimetype(element);
                this.src = e.target.result;
                let [, base64] = this.src.split(',');
                this.$emit('change', {
                  size: element.size,
                  type: mimeType,
                  name: element.name,
                  base64: base64
                });
              });
              reader.readAsDataURL(element);
              this.fileNames.push(element.name);
            } else {
              if (event.target.files.length > 1) {
                this.$snotify.error(this.$lang.messages.sn_errorManyFileSizeLimit, 'ERROR');
              } else {
                this.$snotify.error(this.$lang.messages.sn_errorOneFileSizeLimit, 'ERROR');
              }
            }
          }
        }
      } else {
        if (event.target.files && event.target.files[0]) {
          let file = event.target.files[0]
          const filesize = ((file.size/1024)/1024).toFixed(2);
          if (filesize <= 10) {
            let reader = new FileReader()
            reader.addEventListener('load', e => {
              const mimeType = this.generateMimetype(file);
              this.src = e.target.result
              let [, base64] = this.src.split(',')
              this.$emit('change', {
                size: file.size,
                type: mimeType,
                name: file.name,
                base64: base64
              })
            })
            reader.readAsDataURL(file)
            this.fileName = file.name
          } else {
            this.$snotify.error(this.$lang.messages.sn_errorOneFileSizeLimit, 'ERROR');
          }
        }
      }
    },
    deleteAttachment(id) {
      this.fileNames.splice(id, 1);
    },
    /*
      Mimetype for office documents is empty string
      It's hardcoded in order to use this files on mobile application
     */
    generateMimetype(element) {
      const fileName = element.name.split('.');
      const fileExtension = fileName[fileName.length - 1];
      if (fileExtension === 'doc') {
        return 'application/msword';
      } else if (fileExtension === 'docx') {
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      } else if (fileExtension === 'xls') {
        return 'application/vnd.ms-excel';
      } else if (fileExtension === 'xlsx') {
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else {
        return element.type;
      }
    }
  }
}
</script>
